import { OverflownScrollList } from './OverflownScrollList'

/**
 * DS2026 free-text cell (e.g. a "Description" or "Note" column): truncates to a
 * single line and, on a DS2026 (plain) surface, opens a click-to-expand popover
 * showing the full text. Off plain surfaces it falls back to the standard
 * hover tooltip (via OverflownScrollList). Renders "-" when empty.
 *
 * Reuses OverflownScrollList with a single item so long descriptions get the
 * same click-popover treatment as the chain summary cells, without the
 * "N items" count header (only shown for >1 item).
 */
export const DescriptionCell = ({ value }: { value?: string | null }) => {
  if (!value) return <>-</>
  return <OverflownScrollList items={[value]} />
}
